import { animate, style, transition, trigger } from '@angular/animations';

export const growVerticallyAnimation = trigger('growVertically', [
  transition(':enter', [
    style({ height: 0, opacity: 0 }),
    animate('100ms ease-out', style({ height: '*', opacity: 0 })),
  ]),
  transition(':leave', [
    style({ height: '*', opacity: 0 }),
    animate('100ms ease-in', style({ height: 0, opacity: 0 })),
  ]),
]);
